/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Profile_Unlink_ProviderInputs */

const en_profile_unlink_provider = /** @type {(inputs: Profile_Unlink_ProviderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unlink ${i?.label}`)
};

const es_profile_unlink_provider = /** @type {(inputs: Profile_Unlink_ProviderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desvincular ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Unlink {label}" |
*
* @param {Profile_Unlink_ProviderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_unlink_provider = /** @type {((inputs: Profile_Unlink_ProviderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Unlink_ProviderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_unlink_provider(inputs)
	return en_profile_unlink_provider(inputs)
});